import {Component, Input, OnInit} from '@angular/core';
import {PriceUtils} from '../utils/price/price.utils';
import {LanguageService} from '../../services/language/language.service';
import {PriceDetail} from '../../model/ocapi/price-detail';
import {
  productTypeRendition,
  ProductTypeRenditionEnum
} from '../../constants/renditions/product-type-rendition.constants';

@Component({
  selector: 'app-price-detail',
  templateUrl: './price-detail.component.html',
  styleUrls: ['./price-detail.component.less']
})
export class PriceDetailComponent implements OnInit {

  private _priceDetail: PriceDetail;
  private _hasPromo: boolean;

  @Input() isPlay: boolean;
  @Input() promoTextKey: string;
  @Input() rendition: productTypeRendition;
  defaultRendition = ProductTypeRenditionEnum.default;
  StreamingBundleProductTypeRendition = ProductTypeRenditionEnum.streamingBundle;

  @Input()
  omapiId: string;

  @Input()
  set priceDetail(value) {
    this._priceDetail = value;
  }

  constructor(private languageService: LanguageService) {
  }

  ngOnInit(): void {
    this._hasPromo = this._priceDetail && this._priceDetail.hasPromo();
  }

  get priceDetail(): PriceDetail {
    return this._priceDetail;
  }

  get hasPromo(): boolean {
    return this._hasPromo;
  }

  get promoLabel(): string {
    return this._priceDetail ? this._priceDetail.promoLabel : undefined;
  }

  get promoDuration(): number {
    return this._priceDetail ? this._priceDetail.promoDuration : undefined;
  }

  get textIntegerPart(): string {
    return this._priceDetail ? this._priceDetail.price.integerPart() : undefined;
  }

  get textDecimalPart(): string {
    return this.getTextDecimalPart(this._priceDetail ? this._priceDetail.price.decimalPart() : undefined);
  }

  get promoTextDecimalPart(): string {
    return this.getTextDecimalPart(this._priceDetail ? this._priceDetail.promoPrice.decimalPart() : undefined);
  }

  get promoTextIntegerPrice(): string {
    return this._priceDetail ? this._priceDetail.promoPrice.integerPart() : undefined;
  }

  get getCurrentLang(): string {
    return this.languageService.getCurrentLanguage().toLowerCase();
  }

  private getTextDecimalPart(price: string): string {
    return PriceUtils.prefixDecimalPart(price, this.getCurrentLang);
  }

}
